import apiService from "../../../../service/Api";
import { YouTubeChannel } from "../youtubechannel.types";

export interface YouTubeChannelListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: YouTubeChannel[];
}

export const fetchYouTubeChannels = () => {
  return apiService.get<YouTubeChannelListResponse>(
    "/api/configurations/youtube-channels/",
  );
};

export const fetchYouTubeChannel = (id: number) => {
  return apiService.get<YouTubeChannel>(
    `/api/configurations/youtube-channels/${id}/`,
  );
};
